
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c228e402&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Restaurants.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Restaurants.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c228e402!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Restaurants.vue"),
  /* scopeId */
  "data-v-c228e402",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/Views/Restaurants.vue
// module id = 340
// module chunks = 1